import React, { PropTypes, Component } from 'react';
import moment from 'moment';
import Rating from 'react-rating';
import accounting from 'accounting';
import Blazy from 'blazy';
import Classes from './gridhelper/generatePostClassesWithTerms';
const $ = jQuery;

class ProductGridTwo extends Component {
  constructor(props) {
    super(props);
    this.hideLoadingGig = this.hideLoadingGig.bind(this);
    this.state = {
      isotope: false,
    };
  }
  componentDidMount() {
    const self = this;
    const bLazy = new Blazy({
      success: this.hideLoadingGig,
      error: function(ele, msg) {
        // error function
      },
    });
  }
  componentWillMount() {
    const post = this.props.post;
    this.termAsClasses = Classes.generatePostClassesWithTerms(post.terms);
    this.setState({ isotope: this.props.block['type'] === 'isotope' ? true : false });
  }
  componentWillReceiveProps(nextProps) {
    const bLazy = new Blazy({
      success: this.hideLoadingGig,
      error: function(ele, msg) {
        // error function
      },
    });    
  }
  hideLoadingGig(ele) {
    const id = this.props.post.ID;
     $('.dummyClass' + id).removeClass('lazyLoading');
  }
  render() {
    let currencyPosition;
    const { woocommerce } = this.props.helperData;
    switch (woocommerce.position) {
      case 'left':
        currencyPosition = '%s%v';
        break;
      case 'right':
        currencyPosition = '%v%s';
        break;
      case 'left_space':
        currencyPosition = '%s %v';
        break;
      case 'right_space':
        currencyPosition = '%v %s';
        break;
      default:
        break;
    }

    const currencyOptions = {
      symbol: woocommerce.symbol,
      decimal: woocommerce.decimal,
      thousand: woocommerce.thousand,
      precision: woocommerce.number,
      format: currencyPosition,
    };

    const { post, view } = this.props;
    let termAsClasses = this.termAsClasses;
    termAsClasses = termAsClasses !== undefined ? termAsClasses : '';
    const smallPost = post.post_excerpt.substring(0, 80);
    let imgStyle = null;
    if (this.state.isotope === false) {
      imgStyle = {
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      position: 'relative',
      width: '100%',
      height: '100%',
      };
    } else {
      imgStyle = {
      backgroundImage: 'url(' + post.thumb_url + ')',
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      position: 'relative',
      width: '100%',
      height: '100%',
      };
    }

    return (<div>
      { view === 'grid' ? <div>
          <div className="rq-image-grid">
            <div className="rq-grid-normal rq-product-grid product-grid-secondary">
               <div className="post-image-container">
                  <div className={this.state.isotope === false ? 'image-hover-coantainer lazyLoading b-lazy dummyClass' + post.ID : 'image-hover-coantainer'} style={ imgStyle } data-src={this.state.isotope === false ? post.thumb_url : null}>
                    <div className="img-overlay corner"><a href={post.post_link}><i className="ion-link basic-style"></i></a></div>
                  </div>
                </div>
              <div className="post-content rq-product-content">
                <div className="product-title-container">
                  <h2><a href={post.post_link} title={ post.post_title }>{post.post_title}</a></h2>
                  {
                    // <div className="post-text" dangerouslySetInnerHTML={{ __html: post.post_excerpt }}></div>
                  }
                  {
                    this.props.helperData.hasOwnProperty('woocommerce') ? <div><span className="amount" dangerouslySetInnerHTML={{ __html: accounting.formatMoney(post.meta['_price'], currencyOptions) }}></span></div>  : null
                  }
                </div>
                <div className="product-rating">
                  <Rating
                    start= {0}
                    stop= {5}
                    step= {1}
                    initialRate= {parseFloat(post.meta['_wc_average_rating'], 10)}
                    readonly= {true}
                    empty={'ion-android-star-outline'}
                    full= {'ion-android-star'}
                  />
                </div>
              </div>
            </div>
          </div>
      </div>
      :
      <div className="flex-row">
        <div className="flex-md-12 flex-sm-12 flex-xs-12">
          <div className="rq-image-grid">
            <div className="rq-grid-normal with-left-image">
              <div className="flex-row">
                <div className={this.state.isotope === false ? 'flex-md-5 flex-sm-12 flex-xs-12 lazyLoading b-lazy post-image-container-list dummyClass' + post.ID : 'flex-md-5 flex-sm-12 flex-xs-12 post-image-container-list' } style={imgStyle} data-src={this.state.isotope === false ? post.thumb_url : null}>
                     <div className="img-overlay"><a href={post.post_link}><i className="ion-android-add"></i></a></div>
                </div>
                <div className="flex-md-7 flex-sm-12 flex-xs-12">
                  <div className="post-content">
                    <h2><a href={post.post_link}>{post.post_title}</a></h2>
                    <span className="post-date">{ moment(post.post_date).format('ll') }</span>
                    <div className={'post-text' + termAsClasses} dangerouslySetInnerHTML={{ __html: post.post_excerpt.slice(0, 70) + '...' }}></div>
                    <a href={post.post_link} className="btn btn-blog">{API.LANG.MORE}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    }
    </div>);
  }
}

ReactiveTemplates['ProductGridTwo'] = ProductGridTwo;

ReactiveLayouts.push({
  'key': 'ProductGridTwo',
  'type': 'all',
  'gridName': 'Product Alt',
});


/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/block/layout/grid/porductAlt.js
 **/